import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url} from '@/utils/baseUrl';


//baocun
export async function saveConfigColumn(params) {
    return post(erpserver+'/deviceLedger/saveConfigColumn', params, true);
}
//字典表 状态\类型
export async function getDeviceDict(params) {
    return post(erpserver+'/deviceLedger/getDeviceDict', params, true);
}
//动态属性
export async function getConfigColumn(params) {
    return post(erpserver+'/deviceLedger/getConfigColumn', params, true);
}